import { useDispatch } from 'react-redux';
import {
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Spinner,
} from 'reactstrap';
import styled from 'styled-components';
import TpIcapCardHeader from '../../../features/tpIcapCardHeader/TpIcapCardHeader';
import {
  MappingState,
  ProgressState,
} from '../../../features/ingest/ingestSlice';
import MappingEditor from './MappingEditor';
import Summary from './Summary';
import MappingActions from '../../../features/ingest/mappingActions';

export default (state: MappingState) => {
  const actions = new MappingActions(useDispatch());
  return (
    <>
      <Row>
        <Col>
          <Card>
            <TpIcapCardHeader>
              <Row>
                <Col md="auto">
                  <h4 className="mt-0">File Contents Summary</h4>
                </Col>
              </Row>
            </TpIcapCardHeader>
            <CardBody>
              <Summary {...state} />
              <Row>
                <Col>
                  <h4 className="mt-0">Map Columns</h4>
                </Col>
              </Row>
              <Row>
                <Col>
                  <MappingEditor {...state} />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row className="justify-content-end mb-2">
        <Col md="auto" className="mr-auto">
          {state.isCancellable && (
            <Button onClick={() => actions.cancelMapping()}>Cancel</Button>
          )}
        </Col>
        <Col md="auto">
          <Button
            className="btn-cta"
            onClick={() => actions.submitMapping(state)}
          >
            Verify Transactions File
          </Button>
        </Col>
      </Row>
      <Modal isOpen={state.cancelling}>
        <ModalHeader color="danger">Cancelling upload</ModalHeader>
        <ModalBody>
          <div className="al-center">
            <Spinner className="mr-3" />
            Please wait...
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};
